import { StyledCounterItem, StyledSubtitle, StyledTextNumber, StyledSpanNumber } from './styles';

export interface CounterItemProps {
    children?: React.ReactNode;
    mainNumber: string;
    additionalText: string;
    text: string;
}

const CounterItem: React.FC<CounterItemProps> = ({
    children,
    mainNumber,
    additionalText,
    text,
}) => {
    return (
        //TODO  Przepisać na chakra UI
        <StyledCounterItem>
            <StyledTextNumber>
                <StyledSpanNumber>{mainNumber}</StyledSpanNumber>
                {additionalText}
            </StyledTextNumber>
            <StyledSubtitle>{text}</StyledSubtitle>
        </StyledCounterItem>
    );
};

export default CounterItem;
